import { useContext } from 'react'

import { EMPTY_OBJECT } from '../../constants/common'
import { MOBILE_SCREEN_MAX_WIDTH } from '../../constants/screen'
import { Screen, ScreenContainerRef } from '../../context'
import { useContainerWidth } from '../useContainerWidth'

// When a `containerRef` is resolved (explicit argument or the nearest
// `ScreenContainerRef` provider), width is measured from the real content
// container (layout-aware). Otherwise the global window-based Screen context
// is returned unchanged, so all existing consumers keep their behavior.
export function useScreen({ containerRef } = EMPTY_OBJECT) {
  const context = useContext(Screen)
  const contextContainerRef = useContext(ScreenContainerRef)

  const resolvedContainerRef = containerRef ?? contextContainerRef ?? null

  const containerWidth = useContainerWidth(resolvedContainerRef)

  if (!resolvedContainerRef) {
    return context
  }

  // Fall back to the context width until the first measurement lands
  // (ResizeObserver fires once the ancestor ref is attached).
  const width = containerWidth ?? context.width

  return {
    containerRef: resolvedContainerRef,
    containerWidth,
    isMobileScreenSize: width <= MOBILE_SCREEN_MAX_WIDTH,
    screenWidth: context.width,
    width,
  }
}
